export default __webpack_public_path__ + "static/grape-candy-falling-e69f9243a0b2dbfc66c21018911c4706.png";